import { Component, OnInit, ViewChild } from '@angular/core';
import { PlantsService } from '../company/data/plants.service';
import { TranslateService } from '../../services/multilingual/translate.service';
import { JBMSelectOption } from '../../components/JBM/Forms/JBMFormGroups/JBMSelect/JBMSelect.component';
import { JBMDashboardComponent } from '../../components/JBM/Dashboard/jbm-dashboard.component';
import { DashboardDateRange } from './period-pickers/dashboard-date-range-filter/dashboard-date-range-filter.component';
import { DashboardWidgetInstance } from '../../components/JBM/Dashboard/models/dashboard-widget.types';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  dashboardLayout: DashboardWidgetInstance[] | null = null;
  widgetVisibility: Record<string, boolean> = {
    'projects.overview': true,
    'production.today': true
  };
  userRights: any = {};
  plantId: number = 0;
  plantOptions: JBMSelectOption[] = [];

  @ViewChild('dashboard') dashboard: JBMDashboardComponent;

  constructor(
    private PlantsService: PlantsService,
    private TranslateService: TranslateService
  ) { }

  ngOnInit(): void {
    let plants = [];
    this.PlantsService.getData(null).subscribe(
      (data: any) => plants = data.data,
      (error: any) => console.error(error),
      () => {
        if(plants.length > 1) {
          this.plantOptions = this.PlantsService.getSelectOptions(plants);
          this.plantOptions.unshift({ key: '0', value: this.TranslateService.GetTranslation('ui.all') });
        }
      }
    );
  }

  dateRangeChange(dateRange: DashboardDateRange): void {
    this.dashboard?.updateAllWidgetContext({ dateRange });
    console.log('Actuele dashboardperiode:', dateRange);
  }

  saveLayout(layout: DashboardWidgetInstance[]): void {
    this.dashboardLayout = layout;
  }
}
